<script>
const ClinicalReportService = {}

ClinicalReportService.install = function (Vue) {
    var clinicalReportService = new Object()
    Object.defineProperty(Vue.prototype, '$clinicalReportService', { value: clinicalReportService })

    clinicalReportService.getActivityReport = function (fromDate, toDate) {
        var url = '/api/admin/reports?report=clinical-activity&fromDate=' + fromDate + '&toDate=' + toDate
        return Vue.axios.get(url)
            .then(response => { return response.data })
            .catch(error => {
                this.handleError(error)
                return Promise.reject(error)
            })
    }

    clinicalReportService.handleError = function (error) {
        if (error.response) {
            // The request was made and the server responded with a status code that falls out of the range of 2xx
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
        } else if (error.request) {
            // The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
            console.log('error.request ', error.request)
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('error', error.message)
        }
    }
}

export default ClinicalReportService
</script>
